import { useTranslation } from 'react-i18next';
import { Icon } from '../../icon/icon';
import Tag from './Tag';

const TagFittaInstallation = () => {
  const { t } = useTranslation();
  return (
    <Tag
      className={
        'flex py-[4px] px-[6px] items-center gap-[6px] rounded-[4px] bg-[#E0E0E0]'
      }
      label={
        <>
          <span className="flex justify-center items-center w-[14px] h-[14px] gap-[10px]">
            <Icon.ICEngineering />
          </span>
          <span className="text-label-medium font-semib">
            {t("Fitta's Staff Installation")}
          </span>
        </>
      }
    />
  );
};

export default TagFittaInstallation;
